import { z } from "zod";

export const fastenerToolingMappingSchema = z.object({
  partNo: z.string().trim().min(1, "Partname is required").max(100),
  toolingSetId: z.string().trim().min(1, "Tooling Set Id is required").max(100),
});

export type FastenerToolingMappingFormData = z.infer<typeof fastenerToolingMappingSchema>;
